import "./App.css";
import Navbar from "./components/Navbar";
import MainComponent from "./components/MainComponent";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#005691",
      light: "#E8F1F5",
    },
    secondary: {
      main: "#FF7E67",
    },
    default: {
      main: "#E8F1F5",
    },
    text: {
      primary: "#404040",
    },
  },
  typography: {
    fontFamily: ["Nunito"],
  },
});

const App = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Navbar />
        <MainComponent />
      </ThemeProvider>
    </>
  );
};

export default App;
